<template>
  <datalist v-if="objects" :id="id">
    <option
      v-for="[name, size] in sizes"
      :key="size"
      :value="size"
      v-html="name"
    />
  </datalist>
</template>

<script>
import { contains, filter, last, length, map, zip } from "@pdfking/rfunc"
import { All } from "@pdfking/tfunc"

import autocomplete from "../constants/autocomplete"

export default {
  components: {},
  props: ["id", "autocomplete", "units", "min", "max", "target"],

  computed: {
    objects() {
      const response = autocomplete[this.autocomplete]
      return response ? response.objects : null
    },

    sizes() {
      if (this.objects) {
        const unit_filter = length(this.units)
          ? formatted => contains(this.units, last(formatted.split(" ")))
          : formatted => true

        const is_contained = measures =>
          All(
            zip(this.min, measures, this.max),
            ([min, current, max]) => current >= min && current <= max
          )

        return map(
          ([name, formatted, ...sizes]) => [name, formatted],
          filter(
            ([name, formatted, ...sizes]) =>
              unit_filter(formatted) && is_contained(sizes),
            this.objects
          )
        )
      }
      return null
    },
  },
}
</script>
